import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlows({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M11 1H9v3h2V1zM9 0a1 1 0 0 0-1 1v1.5H7A1.5 1.5 0 0 0 5.5 4v1.5H4V4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6.5h1.5V8A1.5 1.5 0 0 0 7 9.5h1V11a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v.5H7a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h1V4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H9zM3 4H1v4h2V4zm6 4h2v3H9V8z"/>
        </svg>
    );
}

export default IconFlows;
